const EMAIL_REGEXP =
  /(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/;

const EMAIL_OR_URL_REGEXP =
  /(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*|((https?:\/\/[^\s]+)?(([a-z0-9\-\%]+\.)+([a-z]{2}|biz|com|edu|gov|info|jobs|net|org|pro|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\%\.]*)(\?[a-z0-9+_\-\.%=&amp;]*)?)?(#[a-zA-Z0-9-=!$&'()*+.=_~:@/?%]*)?)(\s|$)/gim;

export const LinkWrapperRegExps = {
  EMAIL_REGEXP,
  EMAIL_OR_URL_REGEXP,
};

export interface Entry {
  value: string;
  type: 'url' | 'text' | 'email';
  protocol?: string;
  keepProtocol?: boolean; // Whether to display the protocol to the user or not. If user entered the URL with protocol, we shouldn't remove it.
}

// Ensure content with CRLF is not interpreted as a single word
const splitWordsGluedWithCRLF = (content: string): string => content.replaceAll('\n', '\n ');

export const wrapContent = (content: string): Entry[] => {
  const values = splitWordsGluedWithCRLF(content).trim().split(' ');
  return values.map(next => {
    const match = next.match(EMAIL_OR_URL_REGEXP);

    if (match) {
      const matchValue = match[0];
      const isEmail = EMAIL_REGEXP.test(matchValue);

      if (isEmail) {
        return { value: matchValue, type: 'email', protocol: 'mailto:', keepProtocol: false };
      }

      const withProtocolPattern = /^([a-zA-Z0-9]*?):\/\/(.*)/;
      const hasProtocol = withProtocolPattern.test(next);

      if (hasProtocol) {
        const withProtocolMatch = <RegExpMatchArray>next.match(withProtocolPattern);
        return {
          value: withProtocolMatch[2],
          type: 'url',
          protocol: `${withProtocolMatch[1]}://`,
          keepProtocol: true,
        };
      }

      return {
        value: matchValue,
        type: 'url',
        protocol: 'http://',
        keepProtocol: false,
      };
    }

    return { value: next, type: 'text' };
  });
};
